<script>
import { get } from "lodash";
import { HfarmCorporate } from "../../modules/hfarm_corporate_module.js";

export default {
  props: {
    tag: {
      type: String,
      default: "button"
    },
    button: {
      type: Object,
      required: true
    },
    content: {
      type: Object,
      required: false
    },
    containerContent: {
      type: Object,
      required: false
    },
    buttonClass: {
      type: [Object, Array, String],
      default: "btn-primary"
    }
  },
  mounted() {
    Vue.nextTick(() => {
      if (this.isTypeform) {
        HfarmCorporate.initTypeformScript();
      }
      if (this.isZoho) {
        if (globalState.zohoIds.indexOf(this.zohoDivId) == -1) {
          Vue.set(globalState.zohoIds, globalState.zohoIds.length, this.zohoDivId);
          Vue.nextTick(() => {
            HfarmCorporate.zohoInitScript(this.url, this.zohoDivId);
          });
        }
      }
    });
  },
  methods: {
    mayOpenVideoPopup(button) {
      if (button.url === "$video" && this.containerContent) {
        Vue.set(globalState, "videoPopupContent", { content: this.content, containerContent: this.containerContent });
      }
    }
  },
  computed: {
    url() {
      if (this.button && this.button.url) {
        return this.button.url == "$video" ? "javascript:void(0)" : this.button.url;
      } else {
        return "javascript:void(0)";
      }
    },
    href() {
      return (this.isZoho || this.isEmpty) ? "javascript:void(0)" : this.url;
    },
    target() {
      return Fandom.getTarget(this.button);
    },
    title() {
      return get(this, ["button", "title"], "");
    },
    isZoho() {
      return HfarmCorporate.isZohoUrl(this.url);
    },
    isTypeform() {
      return HfarmCorporate.isTypeformUrl(this.url);
    },
    zohoDivId() {
      return `zoho_form_${JSON.stringify(this.button).split('').map(c => c.charCodeAt(0)).join('')}`;
    },
    isEmpty() {
      return this.url.includes("$empty");
    }
  }
};
</script>

<template>
  <div vue-button-component>
    <component
      :is="tag"
      :class="[buttonClass, {'typeform-share typeform-button': isTypeform}]"
      :href="href"
      @click="mayOpenVideoPopup(button)"
      :target="target"
      :data-mode="isTypeform ? 'popup' : ''"
      :data-toggle="isZoho ? 'modal' : ''"
      :data-target="isZoho ? `#${zohoDivId}_modal` : ''"
    >
      <slot>{{title}}</slot>    
    </component>
  </div>
</template>

<style lang="scss">
</style>
